import { render, staticRenderFns } from "./AllExamResults.vue?vue&type=template&id=0baa383a"
import script from "./AllExamResults.vue?vue&type=script&lang=js"
export * from "./AllExamResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0baa383a')) {
      api.createRecord('0baa383a', component.options)
    } else {
      api.reload('0baa383a', component.options)
    }
    module.hot.accept("./AllExamResults.vue?vue&type=template&id=0baa383a", function () {
      api.rerender('0baa383a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/ExamReport/AllExamResults.vue"
export default component.exports